import { guestConstants } from "../_constants/guest.constants";

const initialState = {
    loading: false,
    loaded: false,
    userHash: null,
    hasActiveLeads: false,
    // Active leads that still need documents, each with its uploaded `documents`.
    activeLeads: [],
    error: null,
};

export function guest(state = initialState, action) {
    switch (action.type) {
        case guestConstants.GUEST_DASHBOARD_LOADING:
            return { ...state, loading: true, userHash: action.userHash, error: null };
        case guestConstants.GUEST_DASHBOARD_SUCCESS: {
            const { hasActiveLeads, documentsNeededLeads } = action.dashboard;
            return {
                ...state,
                loading: false,
                loaded: true,
                hasActiveLeads: !!hasActiveLeads,
                activeLeads: documentsNeededLeads || [],
                error: null,
            };
        }
        case guestConstants.GUEST_DASHBOARD_FAILED:
            return { ...state, loading: false, loaded: true, error: action.error };
        default:
            return state;
    }
}
